import IPage from "../../../interfaces/page";
import MainLayout from "../../layouts/Main/Main.layout";
import OrderComponent from "../../Components/Order/Order.component";

const OrderPage: React.FC<IPage> = () => {
    return <MainLayout component={OrderComponent} />
}

export default OrderPage;